import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { getWebFormDataApi } from "../Api";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import BookDemoTemplate from "../components/templates/BookDemoTemplate";
import GetQuoteTemplate from "../components/templates/GetQuoteTemplate";
import SubmitInformationTemplate from "../components/templates/SubmitInformationTemplate";
import EventRegistrationTemplate from "../components/templates/EventRegistrationTemplate";
import { templateBgColors } from "../Config";
import SchoolTemplate from "../components/templates/SchoolTemplate";
import InsuranceTemplate from "../components/templates/InsuranceTemplate.js";
import GetInTouchTemplate from "../components/templates/GetInTouchTemplate.js";
import RealEstateTemplate from "../components/templates/RealEstateTemplate.js";

const Container = styled(Box)(({ theme }) => ({
  width: "100%",
}));

const Page = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const [loading, setLoading] = useState(true);
  const [contentState, setContentSate] = useState({});
  const [formState, setFormState] = useState([]);
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [logoURL, setLogoURL] = useState("");
  const [bgUrl, setBgUrl] = useState("");
  const [bgUrls, setBgUrls] = useState([]);

  const [formData, setFormData] = useState({});
  const getWebformDetails = async () => {
    let response = await getWebFormDataApi({
      formID: queryParams.get("form_id"),
    });

    setFormData(response);
    if (response.hasOwnProperty("schema")) {
      setContentSate(response["schema"]["content_meta"]);
      setFormState(response["schema"]["form_meta"]);
      setPrimaryColor(response["schema"]["primary_color"]);
      setSecondaryColor(response["schema"]["secondary_color"]);
      setLogoURL(response["schema"]["logo_url"]);
      if (response["schema"].hasOwnProperty("bg_url")) {
        if (
          response["schema"]["bg_url"] !== "" &&
          response["schema"]["bg_url"] !== null
        ) {
          setBgUrl(response["schema"]["bg_url"]);
        }
      }

      //multiple bgs for real_estate
      if (response["schema"].hasOwnProperty("bg_urls_list")) {
        setBgUrls(response["schema"]["bg_urls_list"]);
      }
    }
  };
  const init = async () => {
    await getWebformDetails();
    setLoading(false);
  };
  
  const getTheme = ({ primaryColor, secondaryColor }) => {
    const theme = createTheme({
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 900,
          lg: 1200,
          xl: 1536,
        },
      },
      palette: {
        primary: {
          main: primaryColor,
        },
        secondary: {
          main: secondaryColor,
        },
      },
      typography: {
        fontFamily: "Roboto",
      },
    });
    return theme;
  };
  useEffect(() => {
    init();
  }, []);

  const RenderTemplate = () => {
    if (
      formData.hasOwnProperty("template_name") &&
      formData["template_name"] === "book_demo"
    ) {
      return (
        <BookDemoTemplate
          gradientColor={templateBgColors["book_demo"]}
          contentState={contentState}
          formState={formState}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          logoURL={logoURL}
          bgURL={bgUrl}
        />
      );
    } else if (
      formData.hasOwnProperty("template_name") &&
      formData["template_name"] === "get_quote"
    ) {
      return (
        <GetQuoteTemplate
          gradientColor={templateBgColors["get_quote"]}
          contentState={contentState}
          formState={formState}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          logoURL={logoURL}
        />
      );
    } else if (
      formData.hasOwnProperty("template_name") &&
      formData["template_name"] === "submit_information"
    ) {
      return (
        <SubmitInformationTemplate
          gradientColor={templateBgColors["submit_information"]}
          contentState={contentState}
          formState={formState}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          logoURL={logoURL}
          bgURL={bgUrl}
        />
      );
    } else if (
      formData.hasOwnProperty("template_name") &&
      formData["template_name"] === "event_registration"
    ) {
      return (
        <EventRegistrationTemplate
          gradientColor={templateBgColors["event_registration"]}
          contentState={contentState}
          formState={formState}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          logoURL={logoURL}
        />
      );
    } else if (
      formData.hasOwnProperty("template_name") &&
      formData["template_name"] === "admission_form"
    ) {
      return (
        <SchoolTemplate
          contentState={contentState}
          formState={formState}
          primaryColor={primaryColor}
          logoURL={logoURL}
          bgURL={bgUrl}
        />
      );
    } else if (
      formData.hasOwnProperty("template_name") &&
      formData["template_name"] === "real_estate"
    ) {
      return (
        <RealEstateTemplate
          contentState={contentState}
          formState={formState}
          primaryColor={primaryColor}
          logoURL={logoURL}
          bgURLs={bgUrls}
        />
      );
    } else if (
      formData.hasOwnProperty("template_name") &&
      formData["template_name"] === "test_ride_page"
    ) {
      return (
        <InsuranceTemplate
          contentState={contentState}
          formState={formState}
          logoURL={logoURL}
          bgURL={bgUrl}
        />
      );
    } else if (
      formData.hasOwnProperty("template_name") &&
      formData["template_name"] === "get_in_touch"
    ) {
      return (
        <GetInTouchTemplate
          contentState={contentState}
          formState={formState}
          secondaryColor={secondaryColor}
          logoURL={logoURL}
          bgURL={bgUrl}
        />
      );
    }
  };

  return !loading ? (
    Object.keys(formData).length > 0 ? (
      <ThemeProvider
        theme={() =>
          getTheme({
            primaryColor: formData["schema"]["primary_color"],
            secondaryColor: formData["schema"]["secondary_color"],
          })
        }
      >
        <Container>
          <RenderTemplate />
        </Container>
      </ThemeProvider>
    ) : (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Typography>No data found.</Typography>
      </Container>
    )
  ) : (
    <Container
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <CircularProgress />
    </Container>
  );
};

export default Page;
